import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import LoadingPage from "./Loader";

const PrivateRoute = ({ element, allowedRoles = [] }) => {
  const { auth, loading } = useAuth();
  const [redirect, setRedirect] = useState(null);

  useEffect(() => {
    if (loading) return;
    
    const path = window.location.pathname;
    // console.log('PrivateRoute: Current path:', path);
    // console.log('PrivateRoute: Auth object:', auth);
    
    if (!auth) {
      // console.log('PrivateRoute: No auth, redirecting to login');
      if (path !== "/login") setRedirect("/login");
      return;
    }

    // Superadmin logic (check for superAdmin at root level)
    if (auth.superAdmin) {
      // console.log('PrivateRoute: Super admin detected, current path:', path);
      if (!path.startsWith("/superadmin")) {
        // console.log('PrivateRoute: Redirecting super admin to dashboard');
        setRedirect("/superadmin/dashboard");
      }
      return;
    }

    // Role-based access (treat allowedRoles=["superadmin"] as superAdmin)
    if (allowedRoles.length > 0) {
      if (allowedRoles.includes("superadmin")) {
        if (!auth.superAdmin) {
          setRedirect(auth.restaurant ? "/restaurant/dashboard" : "/user");
          return;
        }
      } else if (!(auth.user && allowedRoles.includes(auth.user.role))) {
        setRedirect(auth.restaurant ? "/restaurant/dashboard" : "/user");
        return;
      }
    }

    // Restaurant logic - check if user is trying to access restaurant routes
    if (auth.type === "user" && path.startsWith("/restaurant") && !path.includes("/restaurant/signup")) {
      setRedirect("/user");
      return;
    }
    // Restaurant trying to access user routes
    if (auth.restaurant && path.startsWith("/user")) {
      setRedirect("/restaurant/dashboard");
      return;
    }
  }, [loading, auth, allowedRoles]);

  if (loading) {
    return <LoadingPage />;
  }

  if (redirect) {
    return <Navigate to={redirect} />;
  }

  return element;
};

export default PrivateRoute;
